import Typewriter from "typewriter-effect";
import { home } from "../../config";

// Home 
const Home = () => {

    return (
        <div name='home' className='my-12 py-36 px-8 h-92'>
            <div className='m-8 font-bold text-5xl'>
                {home.tagLine}
            </div>
            <div className='m-8 text-2xl'>
                <Typewriter
                    options={{
                        strings: home.keywords,
                        autoStart: true,
                        loop: true,
                    }}
                />
            </div>
            <div className="m-8">
                <a
                    href={home.resume}
                    className='text-white bg-indigo-900 p-2 rounded-xl'
                >
                    Resume
                </a>
            </div>
        </div>
    );
}

export default Home;
